
import { computed, defineComponent } from "vue";
import qs from "qs";

import {
  ColumnDefinition,
  useDataTable,
  BaseButton,
  DeleteIcon,
  EditIcon,
  CountButton,
  DataTable,
} from "@tager/admin-ui";
import { useResourceDelete } from "@tager/admin-services";
import { Page } from "@tager/admin-layout";

import { deleteSpecial, getSpecialList } from "@/services/requests";
import { SpecialType } from "@/typings/model";
import {
  getFieldListUrl,
  getSpecialFormUrl,
  getProductListUrl,
} from "@/utils/paths";
import { getWebsiteOrigin } from "@/utils/common";

const COLUMN_DEFS: Array<ColumnDefinition<SpecialType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 3,
    name: "Картинка",
    field: "image",
    type: "image",
    style: { width: "100px" },
    headStyle: { width: "100px" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
    type: "name",

    format: ({ row }) => ({
      adminLink: {
        text: row.name,
        url: getSpecialFormUrl({ specialId: row.id }),
      },
      websiteLink: {
        text: getWebsiteOrigin() + row.url,
        url: getWebsiteOrigin() + row.url,
      },
    }),
  },
  {
    id: 4,
    name: "",
    field: "products",
    style: { width: "101px", whiteSpace: "nowrap" },
    headStyle: { width: "101px" },
  },
  {
    id: 5,
    name: "Действия",
    field: "actions",
    style: { width: "101px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "101px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "SpecialList",
  components: {
    BaseButton,
    DeleteIcon,
    EditIcon,
    CountButton,
    DataTable,
    Page,
  },
  setup() {
    const {
      isLoading: isSpecialListLoading,
      rowData: specialList,
      errorMessage,
      searchQuery,
      handleChange,
      fetchEntityList: fetchSpecialList,
    } = useDataTable<SpecialType>({
      fetchEntityList: (params) =>
        getSpecialList({ query: params.searchQuery }),
      initialValue: [],
      resourceName: "Special list",
    });

    const { handleResourceDelete: handleSpecialDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteSpecial,
        resourceName: "Special",
        onSuccess: fetchSpecialList,
      });

    const isRowDataLoading = computed<boolean>(
      () => isSpecialListLoading.value
    );

    function isBusy(specialId: number): boolean {
      return isDeleting(specialId) || isRowDataLoading.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: specialList,
      isRowDataLoading,
      errorMessage,
      isBusy,
      handleSpecialDelete,
      getSpecialFormUrl,
      getFieldListUrl,
      getProductListUrl,
      qs,
      searchQuery,
      handleChange,
    };
  },
});
